<template>
  <!-- Кот-маскот биллинга (растровые ассеты, прозрачный фон).
       variant: fainted (заблокировано — кот в обмороке) | hungry (баланс заканчивается).
       Светлый/тёмный вариант: по умолчанию следует теме приложения; проп dark=false
       форсит чёрного кота (для цветного баннера, где фон не зависит от темы). -->
  <img :src="src" :style="imgStyle" class="billing-cat" alt="" aria-hidden="true" />
</template>

<script>
import faintedLight from "@/assets/billing-cat-fainted.png";
import faintedDark from "@/assets/billing-cat-fainted-dark.png";
import hungryLight from "@/assets/billing-cat-hungry.png";
import hungryDark from "@/assets/billing-cat-hungry-dark.png";

export default {
  name: "BillingCat",
  props: {
    size: { type: [Number, String], default: 120 }, // ширина в px (высота — по пропорции)
    variant: { type: String, default: "fainted" }, // fainted | hungry
    // null → следовать теме приложения; true/false → форсить тёмный/светлый вариант кота.
    dark: { type: Boolean, default: null },
  },
  computed: {
    isDark() {
      return this.dark === null ? !!this.$vuetify.theme.dark : this.dark;
    },
    src() {
      if (this.variant === "hungry") return this.isDark ? hungryDark : hungryLight;
      return this.isDark ? faintedDark : faintedLight;
    },
    imgStyle() {
      const w = typeof this.size === "number" ? `${this.size}px` : this.size;
      return { width: w, height: "auto", display: "block" };
    },
  },
};
</script>
